<template>
  <header v-if="portalGeneralInfo.hasHeader">
    <b-navbar
      fixed="top"
      toggleable="md"
      class="header-component py-md-1 py-xxs-2"
      :type="this.portalGeneralInfo.theme"
      :variant="this.portalGeneralInfo.theme"
    >
      <b-navbar-brand class="float-right d-none d-md-block logoplaceholder" to="/">
        <img :src="portalGeneralInfo.logoUrl" class="logo d-inline-block align-top" :to="{name:'home'}"/>
      </b-navbar-brand>
      <b-navbar-brand class="d-inline-block d-md-none logoplaceholder" to="/">
        <b-img :src="portalGeneralInfo.logoUrl" class="logo align-top" :to="{name:'home'}"/>
      </b-navbar-brand>

      <b-navbar-nav  v-if="portalGeneralInfo.hasMenu" class="m-0 p-0">
        <div id="nav-toggle" @click="toggleNav()" :class="{'visible':navToggle}">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </b-navbar-nav>




      <b-collapse id="nav_collapse" :class="{'visible': navToggle}" is-nav class="hamburger-menu justify-content-end">
        <b-navbar-nav class="m-0">
          <b-nav-item v-if="isUserLoggedIn" class="d-md-none">
             <span class="d-flex align-self-center my-1">
          <img height="110" src="@/assets/icons/avatar.svg">
        </span>
        <span class="mx-2 mt-3 d-flex align-self-center">
          {{ displayName }}
        </span>
          </b-nav-item>
          <div class="dropdown-divider" v-if="isUserLoggedIn"/>
          <b-nav-item @click="userProfile" v-if="isUserLoggedIn"  class="d-md-none">
            <i class="text-muted icon icon-cog"></i>
            {{$t('UserProfile.Common.Profile')}}
          </b-nav-item>
          <b-nav-item v-if="isUserLoggedIn" @click="userLogout"  class="d-md-none">
            <i class="text-muted icon icon-logout"></i>
            {{$t('header.logout')}}
            </b-nav-item>
        <b-nav-item
          v-if="!isUserLoggedIn && tenantLoginType === 'organic'"
          class="ml-auto p-0 d-md-none"
          @click="login"
        >
        <i class="icon icon-user" />
        <span class="d-block float-right">
          {{ $t('header.loginRegister') }}
        </span>
        </b-nav-item>
          <div class="dropdown-divider" />
           <b-nav-item class="d-md-none" :to="{ name: 'home' }"
           @click="toggleNav()"
            exact>
             <i class="text-muted icon icon-home"></i>
             <span class="d-block float-right">
            {{ $t('header.home') }}
             </span>
          </b-nav-item>
          <b-nav-item
            :to="{ name: 'products' }"
            @click="toggleNav()"
            class="d-md-none"
            exact
          >
          <i class="text-muted icon icon-list-bullets"></i>
          <span class="d-block float-right">
            {{ $t('header.productsList', {products: this.globalResources.productTranslation.Plural}) }}
          </span>
          </b-nav-item>
          <b-nav-item class="d-md-none" :to="{ name: 'genres' }"
          @click="toggleNav()"
           exact>
             <i class="text-muted icon icon-genres"></i>
             <span class="d-block float-right">
            {{ $t('header.genres') }}
             </span>
          </b-nav-item>
        </b-navbar-nav>
        <div class="dropdown-divider" />
        <b-navbar-nav class="d-md-none">
          <b-nav-item
            v-for="(collection, index) in orderedCollections"
            :key="index"
            @click="toggleNav()"
            :to="'/collection/' + collection.id"
            exact
          >
          <template v-if="collection.icon">
            <i :class="['icon', `icon-${collection.icon}`]" />
          </template>
          <template v-else>
            <i class="icon icon-profile-game-controller-inactive" />
          </template>
          <span class="d-block float-right">
            {{ collection.name }}
            </span>
          </b-nav-item>
        </b-navbar-nav>
        <div class="dropdown-divider" />
         <b-navbar-nav v-if="tenantLoginType === 'organic'">
          <b-nav-item 
          href="https://bazi.li/intro"
          @click="toggleNav()"
          class="d-md-none"
          exact>
          <i class="text-muted icon icon-info"></i>
          <span class="d-block float-right">
          {{ $t('header.aboutBazili') }}
          </span>
        </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav>
            <b-nav-item 
            :to="{ name: 'terms' }"
            @click="toggleNav()"
            class="d-md-none"
            exact>
            <i class="text-muted icon icon-shield"></i>
            <span class="d-block float-right">
            {{ $t('header.termsAndConditions') }}
            </span>
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav v-if="tenantLoginType === 'organic'">
          <b-nav-item 
          href="https://bazi.li/download/com.bazillion.bazilli(1.3.0)-release.apk"
          @click="toggleNav()"
          class="d-md-none"
          exact>
          <i class="text-muted icon icon-download"></i>
          <span class="d-block pt-1 float-right">
          {{ $t('header.downloadApp') }}
          </span>
        </b-nav-item>
        </b-navbar-nav>
      </b-collapse>

      <b-navbar-nav v-if="portalConfigurations.general.hasHeaderButtons" class="p-0 m-0 d-none d-md-block justify-content-end">
        <b-nav-item class="genre-nav-item">
          <GenresMenu></GenresMenu>
        </b-nav-item>
      </b-navbar-nav>
      <!--<b-navbar-nav v-if="portalConfigurations.general.Skin === 'put'">-->
        <!--<b-nav-item -->
          <!--@click="returnToApp"-->
          <!--exact >-->
          <!--{{ $t('header.returnToApp') }}-->
        <!--</b-nav-item>-->
      <!--</b-navbar-nav>-->
      <b-navbar-nav v-if="portalConfigurations.general.hasHeaderButtons"
class="d-none d-md-block p-0" >
        <b-nav-item 
                    :to="{ name: 'products' }"
          @click="toggleNav()"
          exact >
          {{ $t('header.productsList', {products: this.globalResources.productTranslation.Plural}) }}
        </b-nav-item>
      </b-navbar-nav>
       

      <div class="hamburger-overlay" :class="{'visible': navToggle}" @click="toggleNav()" />

      <b-navbar-nav class="p-0 m-0 d-none d-md-block justify-content-end">
        <b-nav-item v-if="isUserLoggedIn && tenantLoginType === 'organic'" :to="{name:'profile'}">
          <LogoutForm></LogoutForm>
        </b-nav-item>
        <b-nav-item
          v-if="!isUserLoggedIn && tenantLoginType === 'organic'"
          class="ml-auto p-0 bt-loginregister"
          @click="login"
        >
        <b-button variant="success" class="mx-1">
          {{ $t('header.loginRegister') }}
        </b-button>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </header>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { userInfo } from 'os'
import LogoutForm from '@/components/LogoutForm'
import GenresMenu from '@/components/GenresMenu'
import RootAccessor from '@/mixins/root-accessor'

export default {
  name: 'OrganicHeader',
  data() {
    return {
      navToggle: false
    }
  },
  components:{
    LogoutForm,
    GenresMenu
  },
  computed: {
    ...mapGetters({
      tenantDesignConfig: 'tenantDesign/config',
      userInfo: 'userDemographic/userInfo',
      isUserLoggedIn: 'auth/isUserAuthenticated',
      collections: 'productCatalog/collections',
      portalConfigurations: 'tenantDesign/config',
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    },
    orderedCollections()
    {
      return this.collections.sort((a,b)=>{
        return a.menuOrder - b.menuOrder
      }).slice(0,4)
    },
    tenantLoginType () {
      return this.tenantDesignConfig.userManagement.loginType.toLowerCase()
    },
    displayName () {
      return this.userInfo.username ? this.userInfo.username : this.userInfo.email
    }
  },
  mixins: [RootAccessor],
  created () {
    if (this.collections.length === 0) {
      this.loadCollections()
    }
    if (this.isUserLoggedIn) {
      this.loadUserInfo()
    }
  },
  mounted () {
    if (this.isUserLoggedIn) {
      this.loadUserInfo()
    }
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
      initUnsub: 'subscription/initUnsub',
      loadCollections: 'productCatalog/loadCollections',
      showLogin: 'navigation/showLogin',
      showUnsub: 'navigation/showUnsub',
      loadUserInfo: 'userDemographic/loadUserInfo'
    }),
    login () {
      this.toggleNav()
      this.$ga.event('Registration', 'MenuLogin/Register')
      this.$router.push({ name: 'login' })
    },
    toggleNav() {
      this.navToggle ? this.navToggle = false : this.navToggle = true
    },
    SetInitialData() {
      this.loadUserInfo().then(response => {

      })
    },
    userLogout() {
      this.toggleNav()
      this.logout()
      window.location.href = window.location.origin
    },
    userProfile() {
      this.toggleNav()
      this.$router.push({ name: 'profile' })
    },
    returnToApp() {
      let os = this.getMobileOperatingSystem()
      if (os === 'iOS') {
        var fallbackLink = this.portalGeneralInfo.iosLink
       /* window.location.replace("yourapp://path/") 
        setTimeout(function () {
        window.location.replace("https://itunes.apple.com/app/id12345678") }, 2000)*/
      } else if (os === 'Android') {
        var fallbackLink = this.portalGeneralInfo.androidLink
        window.setTimeout(() => { window.location.replace(fallbackLink) }, 1)
      }
    },
  }
}
</script>
